/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestDto } from '../../models/contents-request-dto';
import { UpdateContentsRequestDto } from '../../models/update-contents-request-dto';

export interface ContentsRequestControllerUpdate$Params {
  contentsRequestId: string;
  clientWorkspaceId: string;
      body: UpdateContentsRequestDto
}

export function contentsRequestControllerUpdate(http: HttpClient, rootUrl: string, params: ContentsRequestControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('contentsRequestId', params.contentsRequestId, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestDto>;
    })
  );
}

contentsRequestControllerUpdate.PATH = '/api/contents-request/{contentsRequestId}/{clientWorkspaceId}';
